import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import { useField } from 'formik'

import { commonMuiStyles } from '../../assets/styles/CommonMUIStyles';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

const FieldWrapper = ({ name, ...otherProps }) => {
	const [field, meta] = useField(name)
	const classes = commonMuiStyles();
	const [showPassword, setShowPassoword] = useState(false)
	const [isFocused, setIsFocused] = useState(false)
	const isPasswordField = name === "password" || name === "confirmPassword" || name === 'newPassword';
	
	const handleClickShowPassword = () => {
		setShowPassoword(!showPassword);
	}

	const getAutocomplete = () => {
		if (name === 'password') return 'current-password';
		if (name === 'newPassword') return 'new-password';
		if (name === 'confirmPassword') return 'new-password';
		if (name === 'email') return 'email';
		if (name === 'phone_number') return 'tel';
		if (name === 'name') return 'name';
		if (name === 'address') return 'street-address';
		return 'off';
	}

	const configTextField = {
		fullWidth: true,
		variant: 'outlined',
		...field,
		...otherProps,
		autoComplete: getAutocomplete(),
		onFocus: (e) => { setIsFocused(true); otherProps.onFocus?.(e); },
		onBlur: (e) => { setIsFocused(false); field.onBlur(e); otherProps.onBlur?.(e); },
	}

	if (meta && meta.touched && meta.error) {
		configTextField.error = true
		configTextField.helperText = meta.error
	}

	return <TextField 
		type={isPasswordField ? (showPassword ? "text" : "password") : (otherProps.type || "text")} 
		className={classes.root}  
		{...configTextField}
		InputLabelProps={{ shrink: isFocused || !!field.value }}
		InputProps={{
			endAdornment: isPasswordField && (
				<InputAdornment position="end">
					<IconButton onClick={handleClickShowPassword}>
						{showPassword ? <Visibility className={classes.iconStyle} /> : <VisibilityOff className={classes.iconStyle} />}
					</IconButton>
				</InputAdornment>
			),
		}} />
}

export default FieldWrapper;
